const content = `<b style="font-size: 2.2rem;">Privacy Policy for Registration</b>

We are pleased that you wish to register with manny+nanny | THE BABYSITTER AGENCY, a business division of Lenssen GmbH. As part of your registration, we process your personal data in order to create a user account for you as an interested user, family, or potential job seeker. To do so, it is necessary that you agree to our linked General Terms and Conditions (GTC) as well as our linked Privacy Policy.

Furthermore, you can optionally subscribe to our newsletter. In this case, you will receive valuable tips, exciting insights, and exclusive content on childcare at most once a month. Both your consent to registration and to receiving the newsletter can be revoked at any time with effect for the future.

Detailed information on data processing and your rights in accordance with the GDPR can be found in our complete Privacy Policy.
`

function PrivacyPolicyRegisterEn(props) {
    console.log("mu");
    return (
        <div className="text_2_black" style={{whiteSpace: "pre-wrap"}} dangerouslySetInnerHTML={{__html: content}}/>
    );
}

export default PrivacyPolicyRegisterEn;
